import { ProjectLinks } from 'components/extra/ProjectLinks';
import './ProjectShowcase.scss';

export const ProjectShowcase = ({ project }) => {
    const { id, coverProjectMobile, title, purpose, areas, technologiesList } = project;

    return (
        <div className='projectshowcase' id={id}>
            <div className="projectshowcase__cover">
                <img
                    src={coverProjectMobile}
                    alt={title}
                    className="projectshowcase__image"
                />
            </div>
            <div className="projectshowcase__details">
                <div className="projectshowcase__intro">
                    <h2 className="projectshowcase__title">{title}</h2>
                    <p className="projectshowcase__description">{purpose}</p>
                </div>
                <ul className="projectshowcase__list projectshowcase__list--areas">
                    {
                        areas.map(area => {
                            return (
                                <li className="projectshowcase__area"
                                    key={area.id}>
                                    <h3 className="projectshowcase__subtitle">
                                        {area.title}
                                    </h3>
                                    <ul className="projectshowcase__list projectshowcase__list--technologies">
                                        {
                                            technologiesList[area.key].map(tech => {
                                                return (
                                                    <p
                                                        key={tech.id}
                                                        className="projectshowcase__tech"
                                                    >{tech.title}</p>
                                                )
                                            })
                                        }
                                    </ul>
                                </li>
                            )
                        })
                    }
                </ul>
                <ProjectLinks project={project} />
            </div>
        </div>
    )
}